import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { MailboxFilterOptions } from '../models/mailbox-filter-option';
import { MailboxRegisterListItem } from '../models/mailbox-register-results.model';

const area = 'Mailbox Register';
export const mailboxRegisterAdapterActions = createRegisterActions<MailboxRegisterListItem>(area);

export const mailboxRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: MailboxFilterOptions[] }>()
);
